import { z } from 'zod';
import type OpenAI from 'openai';

export type LlmParams = Omit<OpenAI.ChatCompletionCreateParams, 'model'>;
// TODO: define a proper schema
export const LlmParams = z.custom<LlmParams>();

/** Structural subset of OpenAI's chat-completions usage; the fields we persist/derive from. */
export const OpenAiUsageShape = z.object({
  prompt_tokens: z.number(),
  completion_tokens: z.number(),
  prompt_tokens_details: z.object({ cached_tokens: z.number().optional() }).optional(),
});
export type OpenAiUsageShape = z.infer<typeof OpenAiUsageShape>;

// Compile-time guard that our shape stays a structural subset of the real OpenAI usage type.
const _assertUsageSubset = (usage: OpenAI.Completions.CompletionUsage): OpenAiUsageShape => usage;
void _assertUsageSubset;

/** A stored raw OpenAI response body, narrowed to the usage block we read back. */
export const OpenAiResponseWithUsage = z.object({ usage: OpenAiUsageShape });
